import React, { useContext, useEffect, useRef } from "react";
import {
    TokenContext,
} from "../../Store";

import { makeStyles } from "@mui/styles";

import {connect} from "react-redux";

import LoadingIndicator from "../../../shared/LoadingIndicator";
import {trackPromise} from "react-promise-tracker";
import UserService from "../../../services/UserService";
import BimetaDataService from "../../../services/BimetaDataService";
import MaterialTable from "@material-table/core";
import {header} from "../../../shared/headerStyle";

const TOOLBAR_HEIGHT = 74;
const PAGINATION_HEIGHT = 52;
const BORDER = 1;

const useStyles = makeStyles({
    root: {
        textAlign: "left",
        fontFamily: "poppins",
    },
    lightButton: {
        float: "right",
        fontWeight: "bold",
    },
    darkButton: {
        float: "right",
        color: "#e5e5e5",
        fontWeight: "bold",
    },
    katalogView: {
        width: "100%",
        height: "100%",
        float: "left",
    },
    btListe: {
        width: "100%",
        maxHeight: "100vh",
        float: "left",
    },
});

const cafmIdentifier = 'CAFMConnect.DE';

function BimetaData({theRealm}) {
    const [token] = useContext(TokenContext);
    const [classificationsystems, setClassificationsystems] = React.useState([]);

    const classes = useStyles();

    useEffect(() => {
        if (!UserService.isLoggedIn()) {
            UserService.doLogout();
        }
    }, []);

    useEffect(() => {
        async function fetchData() {
            try {
                const res = await BimetaDataService.getClassificationsytem(token, theRealm, cafmIdentifier);
                if (res.data) {
                    const csData = [];
                    for (const cs of res.data) {
                        for (const csVersion of cs.classificationSystemVersions) {
                            csData.push({
                                id: cs.id,
                                name: cs.name,
                                identifier: cs.identifier,
                                version: cs.version,
                                publicationDate: cs.publicationDate,
                                versionCreateDate: csVersion.createDate,
                                versionName: csVersion.name,
                                versionId: csVersion.id,
                                versionPublishDate: csVersion.publishDate,
                            });
                        }
                    }
                    setClassificationsystems(csData);
                }
            } catch (e) {
                console.error("Fehler beim Laden der Klassifikationssysteme:", e);
            }
        }
        fetchData();
    }, []); // eslint-disable-line react-hooks/exhaustive-deps

    return (
        <div>
            <LoadingIndicator />
            <div className={classes.katalogView}>
                <div className={classes.btListe}>
                    <BimetaClassificationSystemListView
                        classificationsystems={classificationsystems}
                        realm={theRealm}
                    />
                </div>
            </div>
        </div>
    );
}

function BimetaClassificationSystemListView({ classificationsystems, realm }) {
    const [token] = useContext(TokenContext);
    const tableRef = useRef();
    const tableHeight = (window.innerHeight - TOOLBAR_HEIGHT - PAGINATION_HEIGHT - BORDER) / window.innerHeight * 100;

    const addClasses = async (rowData) => {
        try {
            await trackPromise(BimetaDataService.getClassesVersioned(token, realm, rowData.id, rowData.versionId));
        } catch (err) {
            console.error("Fehler beim Importieren der Classes:", err);
        }
    };

    const addClassificationSystem = async (rowData) => {
        try {
            await trackPromise(BimetaDataService.saveClassificationsytem(token, realm, rowData));
        } catch (err) {
            console.error("Fehler beim Importieren des Klassifikationssystems:", err);
        }
    };

    const addEnumerations = async (rowData) => {
        try {
            await trackPromise(BimetaDataService.getEnumerators(token, realm, rowData.id));
        } catch (err) {
            console.error("Fehler beim Importieren der Enumeratoren:", err);
        }
    };

    const addUnitcodes = async () => {
        try {
            await trackPromise(BimetaDataService.getUnitCodes(token, realm));
        } catch (err) {
            console.error("Fehler beim Importieren der Unitcodes:", err);
        }
    };

    const addPropertyTypes = async () => {
        try {
            await trackPromise(BimetaDataService.getPropertyTypes(token, realm));
        } catch (err) {
            console.error("Fehler beim Importieren der Propertytypes:", err);
        }
    };

    return (
        <>
            <MaterialTable
                tableRef={tableRef}
                title="Bimeta Classificationsystems zu CAFMConnect.DE"
                columns={[
                    { title: 'Name', field: 'name' },
                    { title: 'Version', field: 'versionName' },
                    { title: 'VersionId', field: 'versionId' },
                    { title: 'Datum CS', field: 'publicationDate', type: "date",
                        dateSetting: { locale: "de-DE", format: 'dd.MM.yyyy' } },
                    { title: 'Version Date', field: 'versionCreateDate', type: "date",
                        dateSetting: { locale: "de-DE", format: 'dd.MM.yyyy' } },
                    { title: 'Publish Date', field: 'versionPublishDate', type: "date",
                        dateSetting: { locale: "de-DE", format: 'dd.MM.yyyy' } },
                    { title: 'id', field: 'id' },
                ]}
                data={classificationsystems}
                options={{
                    headerStyle: header,
                    actionsColumnIndex: -1,
                    pageSize: 10,
                    pageSizeOptions: [10, 20, 50, 100],
                    exportButton: false,
                    exportAllData: false,
                    maxBodyHeight: `${tableHeight}vh`,
                    minBodyHeight: `${tableHeight}vh`,
                }}
                actions={[
                    {
                        icon: 'keyboard',
                        tooltip: 'Classificationssystem importieren',
                        onClick: (event, rowData) => addClassificationSystem(rowData),
                        disabled: !UserService.hasRole(['ADMIN_MAP', 'MAP_ADMIN'])
                    },
                    {
                        icon: 'iso',
                        tooltip: 'Classes importieren',
                        onClick: (event, rowData) => addClasses(rowData),
                        disabled: !UserService.hasRole(['ADMIN_MAP', 'MAP_ADMIN'])
                    },
                    {
                        icon: 'gradient',
                        tooltip: 'Enumeratoren importieren',
                        onClick: (event, rowData) => addEnumerations(rowData),
                        disabled: !UserService.hasRole(['ADMIN_MAP', 'MAP_ADMIN'])
                    },
                    {
                        icon: 'input',
                        tooltip: 'Unitcodes importieren',
                        onClick: (event, rowData) => addUnitcodes(rowData),
                        disabled: !UserService.hasRole(['ADMIN_MAP', 'MAP_ADMIN'])
                    },
                    {
                        icon: 'memory',
                        tooltip: 'Propertytypes importieren',
                        onClick: (event, rowData) => addPropertyTypes(rowData),
                        disabled: !UserService.hasRole(['ADMIN_MAP', 'MAP_ADMIN'])
                    },
                ]}
                localization={{
                    pagination: {
                        labelDisplayedRows: '{from}-{to} von {count}',
                        labelRowsSelect: 'Zeilen',
                        labelRowsPerPage: 'Zeilen pro Seite'
                    },
                    toolbar: {
                        nRowsSelected: '{0} Zeile(n) ausgewählt',
                        searchTooltip: 'Suchen',
                        searchPlaceholder: 'Suchbegriff eingeben'
                    },
                    header: {
                        actions: ''
                    },
                    body: {
                        emptyDataSourceMessage: 'Keine Einträge gefunden',
                        filterRow: {
                            filterTooltip: 'Filter'
                        },
                        editRow: {
                            deleteText: 'Soll der Datensatz wirklich gelöscht werden?',
                            saveTooltip: 'Speichern',
                            cancelTooltip: 'Abbrechen'
                        }
                    }
                }}
            />
        </>
    );
}

function mapState({theRealm}) {
    return {
        theRealm: theRealm
    }
}

export default connect(
    mapState,
    null
)(BimetaData);